// extracted by mini-css-extract-plugin
module.exports = {"h5button":"g2","h5Button":"g2","button":"g3","block":"g4","btnDefault":"g5","disable":"g6","btnPrimary":"g7"};